import { Component, OnInit, Input } from '@angular/core';

import { AuthenticationService } from '../../../services/common/authentication.service';
import { PersistentStorageService } from '../../../services/common/persistent-storage.service';

import { USER_KEY } from '../../../constants/user-constants';

@Component({
	selector: 'app-header-staff',
	templateUrl: './header-staff.component.html',
	styleUrls: [ './header-staff.component.scss' ]
})
export class HeaderStaffComponent implements OnInit {
	constructor(
		private readonly auth: AuthenticationService,
		private readonly persistentStorageService: PersistentStorageService
	) {}
	showLogout = false;
	clicked = false;

	public facultyListingNav = true;
	@Input() staffData;
	@Input() controlListObject;

	ngOnInit() {
		if (location.href.split('#')[1].split('/')[1] === 'listing') {
			this.facultyListingNav = true;
		} else {
			this.facultyListingNav = false;
		}
	}
	public viewDropdown() {
		this.showLogout = !this.showLogout;
	}
	onClickedOutside(e: Event) {
		this.showLogout = false;
	}
	public clickMenu() {
		this.clicked = true;
	}

	/**
  	* @description logout functionality
  	*/
	public logout() {
		this.persistentStorageService.removeLocalStorage(USER_KEY.CURRENT_STAFF_EMAIL);
		this.persistentStorageService.removeLocalStorage(USER_KEY.CURRENT_STUDENT_EMAIL);
		this.persistentStorageService.removeLocalStorage(USER_KEY.CURRENT_PROGRAM_CODE);
		this.persistentStorageService.removeLocalStorage(USER_KEY.CURRENT_TEMPLATE_ID);
		this.auth.logout();
	}
}
